import React from 'react'
import errorRobot from '../Assets/error_robot.webp'
import BackToHome from './BackToHome'
import Navbar from './Navbar'

function ErrorPage() {
  return (
<>
<Navbar/>
<div className='errorPage'>
      <h3 className='text-center' style={{padding:"8px"}}>Sorry I broke</h3>
      <p className='p-4 fw-bold'>Either I am a Work in Progress page, or you are visiting a page which no longer exists 💀 </p>
      <img src={errorRobot} alt="Error 404" />
      <BackToHome/>
    </div>
</>
  )
}

export default ErrorPage
